import React, { useEffect, useState } from "react";
import { Drawer, Table, Typography, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import PropTypes from "prop-types";
import GetInitiativeWorkFlow from "../../../hooks/Editpage/GetInitiativeWorkFlow";
import Tooltip from "@mui/material/Tooltip";

const WorkflowInfo = ({ open, onClose, initiativesID }) => {
  const [initiativeWorkFlow, setInitiativeWorkFlow] = useState();

  // Fetch workflow data when the component mounts or when initiativesID changes
  useEffect(() => {
    const fetchWorkFlow = async () => {
      const workFlow = await GetInitiativeWorkFlow(initiativesID);
      setInitiativeWorkFlow(workFlow);
    };

    if (initiativesID) {
      fetchWorkFlow();
    }
  }, [initiativesID]);

  // Process workflow data to group actions by stage
  const workflowData = React.useMemo(() => {
    // const groups = initiativeWorkFlow?.data?.groupedWorkflows ?? [];
      const groups = initiativeWorkFlow?.data?.listInitiativeWorkflowEntity ?? [];

    // Create a map to group actions by stage name
    const stageMap = new Map();

    // groups.forEach(group => {
    //   const stageName = group.fromStageName;
    //   const actions = group.actions ?? [];
    groups.forEach(group => {
      const stageName = group.FromStageName;
      const actions = group.GroupedItems ?? [];

      if (stageMap.has(stageName)) {
        // If stage already exists, add actions to it
        stageMap.get(stageName).actions.push(...actions);
      } else {
        // Create new stage entry
        stageMap.set(stageName, {
          stageName,
          actions: [...actions],
          // Use the first action's details for stage-level info
          firstAction: actions[0] || {}
        });
      }
    });

    // Convert map to array and sort by the earliest action time in each stage
    const stageArray = Array.from(stageMap.values());

    // Sort stages by the earliest action time
    stageArray.sort((a, b) => {
      const aEarliestTime = Math.min(...a.actions.map(action => new Date(action.eventTime).getTime()));
      const bEarliestTime = Math.min(...b.actions.map(action => new Date(action.eventTime).getTime()));
      return aEarliestTime - bEarliestTime;
    });

    return stageArray;
  }, [initiativeWorkFlow]);

  // Get the overall start and end information
  const getOverallStartEnd = () => {
    if (workflowData.length === 0) return { start: {}, end: {} };

    // Get all actions from all stages
    const allActions = workflowData.flatMap(stage => stage.actions);

    // Sort by time to get first and last
    const sortedActions = allActions.sort((a, b) => new Date(a.eventTime) - new Date(b.eventTime));

    return {
      start: sortedActions[0] || {},
      end: sortedActions[sortedActions.length - 1] || {}
    };
  };

  const { start: startStage, end: endStage } = getOverallStartEnd();

  const getAllStages = () => {
    if (workflowData.length === 0) return [];

    const stages = [];

    // Add all workflow stages
    workflowData.forEach((stageInfo, index) => {
      stages.push({
        stageName: stageInfo.stageName,
        stageData: stageInfo,
        isTransition: true,
        actions: stageInfo.actions
      });
    });

    // Add current stage (final destination)
    if (workflowData.length > 0) {
      // const lastStage = workflowData[workflowData.length - 1];
      // const lastAction = lastStage.actions[lastStage.actions.length - 1];

      // // Only add current stage if it's different from the last stage
      // if (lastAction && lastAction.toStageName !== lastStage.stageName) {
      //   stages.push({
      //     stageName: lastAction.toStageName,
      //     stageData: { firstAction: lastAction },
      //     isTransition: false,
      //     actions: []
      //   });
      // }
      const lastGroup = initiativeWorkFlow?.data?.listInitiativeWorkflowEntity?.slice(-1)[0];
      const toStageName = lastGroup?.ToStageName;

      if (toStageName && toStageName !== lastGroup?.FromStageName) {
        stages.push({
          stageName: toStageName,
          stageData: { firstAction: lastGroup },
          isTransition: false,
          actions: []
        });
      }

    }

    return stages;
  };

  const allStages = getAllStages();

  return (
    <Drawer anchor="right" open={open} onClose={onClose}>
      <div style={{ width: "60vw", padding: "20px" }}>
        <div style={{ backgroundColor: "#f0f0f0", padding: "10px", position: "relative" }}>
          {/* Close Button */}
          <IconButton
            onClick={onClose}
            style={{ position: "absolute", top: 10, right: 10 }}
          >
            <Tooltip title="Close">
              <CloseIcon />
            </Tooltip>
          </IconButton>

          <Typography variant="h6">Workflow Information</Typography>
        </div>

        <div className="details-div py-3">
          <div className="row">
            <div className="details-main-sec">
              <div className="d-sec1 px-1">
                <Table striped className="details-table1 mb-0 w-100">
                  <tbody>
                    <tr>
                      <td>Started :</td>
                      <td className="tital22">
                        {/* Added by Gauri on 12 Nov 2025 */}
                        {/* {startStage?.eventTime
                          ? new Date(startStage.eventTime)
                            .toLocaleDateString("en-GB")
                            .split("/")
                            .join("-")
                          : "N/A"} */}
                        {startStage.eventTime
                          ? new Date(startStage.eventTime).toLocaleDateString("en-GB")
                          : "N/A"}
                      </td>
                    </tr>
                    <tr>
                      {/* Added by Gauri on 12 Nov 2025 */}
                      {/* <td>Originator :</td> */}
                      <td>Created By :</td>
                      <td className="tital22">{startStage?.employeeName || "N/A"}</td>
                    </tr>
                    <tr>
                      <td>Current Stage:</td>
                       <td className="tital22">{endStage?.toStageName || initiativeWorkFlow?.data?.listInitiativeWorkflowEntity?.slice(-1)[0]?.ToStageName || "N/A"}</td>
                    </tr>
                  </tbody>
                </Table>
              </div>
              <div className="vertical-line"></div>
              <div className="d-sec2 px-1">
                <Table striped className="details-table2 mb-0 w-100">
                  <tbody>
                    <tr>
                      <td>Last :</td>
                      <td className="tital22">
                        {/* Commented by Gauri to change date format on 12 Nov 2025 */}
                        {/* {endStage?.eventTime
                          ? new Date(endStage.eventTime)
                            .toLocaleDateString("en-GB")
                            .split("/")
                            .join("-")
                          : "N/A"} */}
                        {/* Added by Gauri to change date format on 12 Nov 2025 */}
                        {endStage?.eventTime
                          ? new Date(endStage?.eventTime).toLocaleDateString("en-GB")
                          : "N/A"}
                      </td>
                    </tr>
                    <tr>
                      <td>Last Actor :</td>
                      <td className="tital22">{endStage?.employeeName || "N/A"}</td>
                    </tr>
                    <tr>
                      <td>Approvers :</td>
                      <td className="tital22">
                        {initiativeWorkFlow?.data?.nextApprovelList?.length > 0 ? (
                          (() => {
                            const approverNames = initiativeWorkFlow.data.nextApprovelList
                              .map(e => e.employeeName)
                              .join(", ");
                            return approverNames.length > 20 ? (
                              <Tooltip title={approverNames}>
                                <span>{approverNames.slice(0, 20)}...</span>
                              </Tooltip>
                            ) : (
                              approverNames
                            );
                          })()
                        ) : (
                          endStage?.comments || "N/A"
                        )}
                      </td>

                    </tr>
                  </tbody>
                </Table>
              </div>
            </div>
          </div>
          <hr className="horizontal-line" />
          <div className="col-sm-4 pt-3">
            <span>Workflow Summary</span>
          </div>
          <div className="details-div py-3">
            <div className="row">
              {allStages.length > 0 ? (
                <div style={{ display: "flex", flexDirection: "column" }}>
                  {allStages.map((stageInfo, index) => {
                    const isFirst = index === 0;
                    const isLast = index === allStages.length - 1;

                    return (
                      <div key={index} style={{ display: "flex", width: "100%", alignItems: "flex-start" }}>
                        {/* LEFT SIDE - Stage and Arrow Column */}
                        <div style={{ width: "60%", display: "flex", flexDirection: "column", alignItems: "center" }}>
                          {/* Stage Box */}
                          <div
                            style={{
                              backgroundColor: isFirst || isLast ? "#ffe873" : "#1a55ffd9",
                              color: isFirst || isLast ? "black" : "white",
                              padding: "10px 20px",
                              borderRadius: isFirst || isLast ? "30px" : "6px",
                              width: "180px",
                              textAlign: "center",
                              marginBottom: isLast ? "10px" : "0",
                              fontWeight: 500,
                            }}
                          >
                            {stageInfo.stageName}
                          </div>

                          {/* Arrow - only show if not last stage */}
                          {!isLast && (
                            <div
                              style={{
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "center",
                                height: `${Math.max(170, stageInfo.actions?.length * 90 + 80)}px`,
                                position: "relative"
                              }}
                            >
                              <div
                                style={{
                                  width: "2px",
                                  height: `${Math.max(110, stageInfo.actions?.length * 80 + 20)}px`,
                                  backgroundColor: "rgb(43, 85, 206)",
                                  marginTop: "10px"
                                }}
                              ></div>
                              {/* Arrow head */}
                              <div
                                style={{
                                  width: "0",
                                  height: "0",
                                  borderLeft: "5px solid transparent",
                                  borderRight: "5px solid transparent",
                                  borderTop: "10px solid rgb(43, 85, 206)",
                                }}
                              ></div>
                            </div>
                          )}
                        </div>

                        {/* RIGHT SIDE - Details Panel */}
                        {/* RIGHT SIDE - Details Panel */}
                        <div
                          style={{
                            width: "40%",
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            justifyContent: "flex-start",
                            position: "relative",
                            top: stageInfo.isTransition ? "20px" : "-20px",
                            marginBottom: stageInfo.isTransition
                              ? `${Math.max(-47, -(stageInfo.actions?.length * 60 - 13))}px`
                              : "0"
                          }}
                        >
                          <>
                            {/* Show all actions for this stage */}
                            {stageInfo.actions.map((action, actionIndex) => (
                              <div
                                key={actionIndex}
                                className="p-2"
                                style={{
                                  display: "flex",
                                  width: "100%",
                                  border: "1px solid",
                                  borderColor:
                                    action.actionType === "SYS_APPROVE"
                                      ? "green"
                                      : action.actionType === "SYS_REJECT"
                                        ? "red"
                                        : action.actionType === "SYS_SUBMIT"
                                          ? "blue"
                                          : "#ccc",
                                  backgroundColor:
                                    action.actionType === "SYS_APPROVE"
                                      ? "#d4edda"
                                      : action.actionType === "SYS_REJECT"
                                        ? "#f8d7da"
                                        : action.actionType === "SYS_SUBMIT"
                                          ? "#d1ecf1"
                                          : "#f0f0f0",
                                  borderRadius: "5px",
                                  marginBottom: "10px"
                                }}
                              >
                                <Table striped className="details-table mb-0 w-100">
                                  <tbody>
                                    <tr>
                                      <td className="col-4" style={{fontSize: "11px"}}>Time :</td>
                                      <td className="col-8 tital22" style={{fontSize: "11px"}}>
                                        {action.eventTime
                                          ? new Date(action.eventTime)
                                            .toLocaleDateString("en-GB")
                                            .split("/")
                                            .join("-")
                                          : "N/A"}
                                      </td>
                                    </tr>
                                    <tr>
                                      <td className="col-4" style={{fontSize: "11px"}}>Actor :</td>
                                      <td className="col-8 tital22" style={{fontSize: "11px"}}>
                                        {action.employeeName || "N/A"}
                                      </td>
                                    </tr>
                                    <tr>
                                      <td className="col-4" style={{fontSize: "11px"}}>Action :</td>
                                      <td className="col-8 tital22" style={{fontSize: "11px"}}>
                                        {action.userActionName || "N/A"}
                                      </td>
                                    </tr>
                                    <tr>
                                      <td className="col-4" style={{fontSize: "11px"}}>Comments :</td>
                                      <td className="col-8 tital22" style={{ fontSize: "11px" }}>
                                        {action.comments && action.comments.length > 30 ? (
                                          <Tooltip title={action.comments}>
                                            <span>{action.comments.slice(0, 30)}...</span>
                                          </Tooltip>
                                        ) : (
                                          action.comments || "N/A"
                                        )}
                                      </td>
                                    </tr>
                                  </tbody>
                                </Table>
                              </div>
                            ))}

                            {/* Waiting for approval block */}
                            {initiativeWorkFlow?.data?.nextApprovelList?.length > 0 && isLast && 
                             // Added a condition to check Completed stage on 17 Nov 2025
                             initiativeWorkFlow?.data?.listInitiativeWorkflowEntity?.slice(-1)[0]?.ToStageOrder !== 100000000 && (
                              <div
                                style={{
                                  backgroundColor: "#fff3cd",
                                  border: "1px solid #ffeeba",
                                  color: "#856404",
                                  padding: "10px 15px",
                                  borderRadius: "8px",
                                  width: "100%",
                                  fontSize: "14px",
                                  fontWeight: 500,
                                  marginTop: "10px"
                                }}
                              >
                                <span style={{ fontWeight: "bold" }}>Waiting for approval...</span>{" "}
                                {/* {initiativeWorkFlow.data.nextApprovelList
                                  .map((e) => e.employeeName)
                                  .join(", ")} */}
                              </div>
                            )}
                          </>
                        </div>

                      </div>
                    );
                  })}
                </div>
              ) : (
                <Typography>No workflow stages available.</Typography>
              )}
            </div>
          </div>
        </div>
      </div>
    </Drawer>
  );
};

WorkflowInfo.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  initiativesID: PropTypes.number.isRequired
};

export default WorkflowInfo;